import { Box, Card, CardContent, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";

export default function LinkedEventCard({
    linkedEvent,
    goToLinkedEvent
}) {

    const theme = useTheme();

    const event = linkedEvent.general ?? linkedEvent;

    return (
        <Card raised onClick={goToLinkedEvent} sx={{
            backgroundColor: theme.palette.background.neutral,
            borderRadius: "8px",
            mb: 1,
            flexShrink: 0,
            width: "268px",
            cursor: "pointer"
        }}>
            <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', py: '8px !important', px: '8px !important' }}>
                {event.images?.[0] && (
                    <Box
                        component="img"
                        src={`${event.images[0]}`}
                        sx={{ width: 56, aspectRatio: '2/3', borderRadius: 1, objectFit: 'cover', flexShrink: 0 }}
                    />
                )}
                <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1, height: 84, justifyContent: "center", }}>
                    <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                        {event.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {dayjs(event.startDate).format('D MMM | HH:mm')}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
}